(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faqs-section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  /* Move FAQ Sections */
  let mainContent = document.querySelector('#main-page-content .content-area');
  let customFaqSections = document.querySelectorAll('div.custom-faq');

  if (mainContent && customFaqSections.length > 0) {
    customFaqSections.forEach(sec => mainContent.append(sec));
  }

  /* Custom Accordion Logic */
  const faqButtons = document.querySelectorAll('.custom-faq .faq-row .faq-box button');

  faqButtons.forEach(button => {
    button.addEventListener('click', function () {
      const row = this.closest('.faq-row');
      const content = this.nextElementSibling;
      const iconOpen = this.querySelector('.collapsible-trigger__icon--open');
      const iconClose = this.querySelector('.collapsible-trigger__icon--close');

      const isOpen = content.classList.contains('open');

      /* Close all items first */
      document.querySelectorAll('.custom-faq .collapsible-content.open').forEach(openContent => {
        openContent.style.height = openContent.scrollHeight + 'px';

        requestAnimationFrame(() => {
          openContent.style.height = '0px';
        });

        openContent.classList.remove('open');

        const openButton = openContent.previousElementSibling;
        if (openButton) {
          openButton.classList.remove('is-open');
          openButton.setAttribute('aria-expanded', 'false');
          openButton.querySelector('.collapsible-trigger__icon--open')?.classList.remove('rotated');
          openButton.querySelector('.collapsible-trigger__icon--close')?.classList.remove('rotated');
        }
      });

      /* If already open, just close it */
      if (isOpen) return;

      /* Open clicked item */
      content.classList.add('open');
      this.classList.add('is-open');
      this.setAttribute('aria-expanded', 'true');

      iconOpen?.classList.add('rotated');
      iconClose?.classList.add('rotated');

      content.style.height = '0px';

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });

      /* Optional scroll */
      setTimeout(() => {
        const y = window.scrollY + this.getBoundingClientRect().top - 60;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 350);
    });
  });

  /* Reset height after animation so content can grow naturally */
  document.querySelectorAll('.custom-faq .collapsible-content').forEach(content => {
    content.addEventListener('transitionend', function () {
      if (this.classList.contains('open')) {
        this.style.height = 'auto';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofs-section-with-toc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let mainContent = document.getElementById('MainContent');
    const tocList = document.getElementById('table-of-contents-list');

    // Target H1, H2, H3, H4 from the rich text content for TOC generation
    const headings = mainContent.querySelectorAll('h2');

    if (!mainContent || !tocList || headings.length === 0) {
      // Hide TOC if no content or no headings found
      const sidebarTocArea = document.querySelector('.sidebar-toc-area .toc-box');
      if (sidebarTocArea) {
        sidebarTocArea.style.display = 'none';
      }
      return;
    }

    let tocHtml = '';
    const headingIds = new Set(); // To ensure unique IDs

    headings.forEach((heading, index) => {
      let id = heading.textContent
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric chars except space and hyphen
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Collapse multiple hyphens
        .trim();

      // Ensure ID is unique if duplicate headings exist
      let originalId = id;
      let counter = 1;
      while (headingIds.has(id)) {
        id = `${originalId}-${counter}`;
        counter++;
      }
      headingIds.add(id);

      heading.setAttribute('id', id); // Add ID to the actual heading on the page

      const level = heading.tagName.toLowerCase(); // h1, h2, h3, h4
      tocHtml += `<li class="${level}-level"><a href="#${id}">${heading.textContent}</a></li>`;
    });

    tocList.innerHTML = tocHtml; // Populate the TOC list

    // Smooth Scrolling Logic
    document.querySelectorAll('#table-of-contents-list a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start', // Scrolls to the top of the element
          });

          // Optional: Update URL hash without jumping
          history.pushState(null, null, targetId);

          // Update active class
          document.querySelectorAll('#table-of-contents-list a').forEach((link) => link.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });

    // Optional: Add active class based on scroll position (more advanced)
    // This part helps highlight the current section in the TOC as user scrolls
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px 0px -70% 0px', // When the top of the heading is 30% from the top of the viewport
      threshold: 0, // As soon as it enters/exits the rootMargin
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute('id');
        const tocLink = document.querySelector(`#table-of-contents-list a[href="#${id}"]`);

        if (tocLink) {
          if (entry.isIntersecting) {
            document.querySelectorAll('#table-of-contents-list a').forEach((link) => link.classList.remove('active'));
            tocLink.classList.add('active');
          }
        }
      });
    }, observerOptions);

    headings.forEach((heading) => {
      observer.observe(heading);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-with-toc"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
    let mainContent = document.getElementById('MainContent');
    const tocList = document.getElementById('table-of-contents-list');
    const STICKY_HEADER_HEIGHT = 50;
    const SCROLL_OFFSET = STICKY_HEADER_HEIGHT + 16;
    // Target H1, H2, H3, H4 from the rich text content for TOC generation
    const headings = mainContent.querySelectorAll('h2');

    if (!mainContent || !tocList || headings.length === 0) {
      // Hide TOC if no content or no headings found
      const sidebarTocArea = document.querySelector('.sidebar-toc-area .toc-box');
      if (sidebarTocArea) {
        sidebarTocArea.style.display = 'none';
      }
      return;
    }

    let tocHtml = '';
    const headingIds = new Set(); // To ensure unique IDs

    headings.forEach((heading, index) => {
      let id = heading.textContent
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric chars except space and hyphen
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Collapse multiple hyphens
        .trim();

      // Ensure ID is unique if duplicate headings exist
      let originalId = id;
      let counter = 1;
      while (headingIds.has(id)) {
        id = `${originalId}-${counter}`;
        counter++;
      }
      headingIds.add(id);

      heading.setAttribute('id', id); // Add ID to the actual heading on the page

      const level = heading.tagName.toLowerCase(); // h1, h2, h3, h4
      tocHtml += `<li class="${level}-level"><a href="#${id}">${heading.textContent}</a></li>`;
    });

    tocList.innerHTML = tocHtml; // Populate the TOC list


    // Smooth Scrolling Logic
    document.querySelectorAll('#table-of-contents-list a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          // targetElement.scrollIntoView({
          //   behavior: 'smooth',
          //   block: 'start' // Scrolls to the top of the element
          // });

            const targetPosition = targetElement.offsetTop - SCROLL_OFFSET;

                // Use window.scrollTo for smooth scrolling with the calculated offset
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

          // Optional: Update URL hash without jumping
          history.pushState(null, null, targetId);

          // Update active class
          document.querySelectorAll('#table-of-contents-list a').forEach(link => link.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });

    // Optional: Add active class based on scroll position (more advanced)
    // This part helps highlight the current section in the TOC as user scrolls
    const observerOptions = {
      root: null, // viewport
      //rootMargin: '0px 0px -70% 0px', // When the top of the heading is 30% from the top of the viewport
      //threshold: 0 // As soon as it enters/exits the rootMargin
        rootMargin: `-${STICKY_HEADER_HEIGHT}px 0px -70% 0px`, 
        threshold: 0 // As soon as it enters/exits the rootMargin
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const tocLink = document.querySelector(`#table-of-contents-list a[href="#${id}"]`);

        if (tocLink) {
          if (entry.isIntersecting) {
            document.querySelectorAll('#table-of-contents-list a').forEach(link => link.classList.remove('active'));
            tocLink.classList.add('active');
          }
        }
      });
    }, observerOptions);

    headings.forEach(heading => {
      observer.observe(heading);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
